import { render } from "./DamageList.vue?vue&type=template&id=0f800be3&scoped=true"
import script from "./DamageList.vue?vue&type=script&lang=js"
export * from "./DamageList.vue?vue&type=script&lang=js"

import "./DamageList.vue?vue&type=style&index=0&id=0f800be3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f800be3"]])

export default __exports__